import axios from 'axios';
import { buildRequests } from '../util/buildRequest';
import { DOMAIN } from '../util/constants';
import { SetAuthHeader } from '../util/SetAuthHeader';
import { SetLanguageHeader } from '../util/SetLanguageHeader';
import { SetResponseInterceptor } from '../util/SetResponseInterceptor';

const API = `${DOMAIN}/api/v1/app-content`;
const instance = axios.create({
  baseURL: API,
});

instance.interceptors.request.use(SetAuthHeader);
instance.interceptors.request.use(SetLanguageHeader);
SetResponseInterceptor(instance);

const requests = buildRequests(instance);

const publicAppContentInstance = axios.create({
  baseURL: API,
});

publicAppContentInstance.interceptors.request.use(SetLanguageHeader);
SetResponseInterceptor(publicAppContentInstance);

const publicAppContentRequests = buildRequests(publicAppContentInstance);

export { API as APP_CONTENT_API, requests as app_content_api_requests, publicAppContentRequests as public_app_content_api_requests };
